import { render } from "./CreateQuestion.vue?vue&type=template&id=2d73cadb&scoped=true"
import script from "./CreateQuestion.vue?vue&type=script&lang=js"
export * from "./CreateQuestion.vue?vue&type=script&lang=js"

import "./CreateQuestion.vue?vue&type=style&index=0&id=2d73cadb&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d73cadb"]])

export default __exports__